
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { LanguageProvider } from './context/LanguageContext';
import './i18n';
import { AuthContextProvider } from './context/AuthContext';
import { LoadingProvider } from './context/LoadingContext';
import axios from 'axios';
import { LessonProvider } from './context/LessonContext';
import { DndProvider } from 'react-dnd-multi-backend';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import { ErrorProvider } from './context/ErrorContext';
import { SoundProvider } from './context/SoundContext';
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import '../src/css/global/elements.css'
// import ErrorBoundary from './components/ErrorBoundary';

// Wrap ResizeObserver callbacks in rAF to prevent loop-notification errors
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      requestAnimationFrame(() => callback(entries, observer));
    });
  }
};

axios.defaults.withCredentials = true;

const isProduction = process.env.REACT_APP_MODE === "prod";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 24 * 60 * 60 * 1000, 
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
  // <ErrorBoundary>
    <HelmetProvider>
      <DndProvider options={HTML5toTouch}>
        <AuthContextProvider>
          <SoundProvider>
            <LanguageProvider>
              <LoadingProvider>
                <LessonProvider>
                  <ErrorProvider>
                    <QueryClientProvider client={queryClient}>
                      <App />
                      {!isProduction && (
                        <ReactQueryDevtools initialIsOpen={false} />
                      )}
                    </QueryClientProvider>
                  </ErrorProvider>
                </LessonProvider>
              </LoadingProvider>
            </LanguageProvider>
          </SoundProvider>
        </AuthContextProvider>
      </DndProvider>
    </HelmetProvider>
  // </ErrorBoundary>
  // </React.StrictMode>
);


// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <React.Suspense fallback='loading'>
//       <App />
//     </React.Suspense>
//   </React.StrictMode>
// );
